$(document).ready(function(){
    if(window.location.hash) {
        $('html,body').scrollTop($(window.location.hash).offset().top - 70);
    }
});
